export enum Experience{
  LESS_THAN_ONE_YEAR,
  BETWEEN_ONE_AND_FIVE_YEARS,
  BETWEEN_FIVE_AND_TEN_YEARS,
  MORE_THAN_TEN_YEARS
}
